import { useMutation, useQuery, useQueryClient } from 'react-query'
import request from '../../../request'
import { useDealership } from '../../../../store/zustand/dealershipStore'

export const useRefetchVendorAdAccounts = () => {
  const dealership = useDealership()
  const queryClient = useQueryClient()
  return useMutation(
    ({ vendor_id }: { vendor_id: number }) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dsp/accounts`,
        method: 'GET',
        params: {
          vendor_id,
          force_refresh: true,
        },
      }),
    {
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(['dsp', 'vendor_accounts', variables.vendor_id])
      },
    },
  )
}
